export const createFrontdeskFormDefaults = () => ({
  firstname: "",
  lastname: "",
  email: "",
  user_password: "",
  phoneno: "",
  clinic_name: "",
  clinic_id: "",
  upi_details: "",
  bank_details: {
    account_holder: "",
    account_number: "",
    bank_name: "",
    ifsc_code: "",
  },
  whatsapp_no: "",
  registration_date: "",
});
